import * as ViewModel from '@/core/presenter/viewModel';
import NoActivityData from './NoActivityData';
import TokenTransactionItem from './TokenTransactionItem';
import { MAX_TRANSACTION_ITEMS } from '@/consts';
import { observer } from 'mobx-react-lite';
import ActivityItemInfo from './ActivityItemInfo';

interface IProps {
  tokenTransactions: ViewModel.IResponseActivity[];
  tokenBalance: string;
  tokenKrw: string;
  onClickResetBtn: () => void;
  onClickViewType: (viewType: ViewModel.HomeViewType) => void;
  onResetSelectedAsset: () => void;
  onClickPrevTransactionBtn: () => void;
  onClickCopyBtn: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const TokenView = observer(
  ({
    tokenTransactions,
    tokenBalance,
    tokenKrw,
    onClickResetBtn,
    onClickViewType,
    onResetSelectedAsset,
    onClickPrevTransactionBtn,
    onClickCopyBtn,
  }: IProps) => {
    const handleClickSendBtn = () => {
      onResetSelectedAsset();
      onClickViewType(ViewModel.HomeViewType.SEND);
    };

    return (
      <div className="container">

        <div className="asset-card">
          <div className="asset-header">
            <img src="./images/gdf-logo.png" alt="GDF" className="asset-logo-icon" />
            <h2 className="asset-title heading-4 font-bold">골든파이낸스</h2>
          </div>


          <div className="detail-asset-info">
            <div className="detail-asset-info-row">
              <h3 className="asset-title heading-2 font-medium">{tokenBalance} GDF
              </h3>
              <button type="button" className="refresh-btn" onClick={onClickResetBtn}>
                <img src="./images/refresh-icon.png" alt="새로고침" className="refresh-icon" />
              </button>
            </div>
            <p className="detail-asset-krw text-base font-normal">{tokenKrw} 원</p>
          </div>


          <div className="asset-buttons">
            <button type="button" className="asset-btn text-base font-semibold" onClick={handleClickSendBtn}>보내기</button>
            <button type="button" className="asset-btn text-base font-semibold" onClick={() => onClickViewType(ViewModel.HomeViewType.RECEIVE)}>받기</button>
          </div>
        </div>
        {tokenTransactions.length === 0 && <NoActivityData />}
        {tokenTransactions.length > 0 && (
          <div className="activity-list activity-list-detail">
            <ul className="list">
              {tokenTransactions.slice(0, MAX_TRANSACTION_ITEMS).map((tokenTransaction, index) => (
                <TokenTransactionItem tokenTransaction={tokenTransaction} key={index} onClickCopyBtn={onClickCopyBtn} />
              ))}
              <ActivityItemInfo onClickPrevTransactionBtn={onClickPrevTransactionBtn} />
            </ul>
          </div>
        )}
      </div>
    );
  },
);

export default TokenView;
